export class ShowForm {
	constructor() {
		this.param = null;
	}


	changeForm(param) {
		//console.log(param);

		let targetElems = document.querySelectorAll('.facility-container');
		let showFormNum = -1;
		for (let i = 0; i < targetElems.length; i++) {
			targetElems[i].classList.remove('show');
			if (targetElems[i].id == param) {
				targetElems[i].classList.add('show');
				showFormNum = i;
			}
		}
		if (showFormNum < 0) {
			targetElems[0].classList.add('show');
		}

		/* urlパラメータを確認する
		.form-container のうち、
		urlパラメータで指定されたものと同じIDがあればそれを表示().show追加)
		#shintokorozawa-th
		#urawa-th
		#kurume-th
		#kurume-footsal
		なければ最初の .form-container を表示

		ex.) /form/trial/?lesson=urawa-th
		*/

		this.loadMap(param);
		//console.log('map start -> ' + param);


		//ie11
		let ie11reload = false;
		//console.log(location.hash);
		if (location.hash) {
			ie11reload = true;
		}

		//最下部に移動
		if (ie11reload) {
			window.setTimeout(() => {
				var element = document.documentElement;
				var bottom = element.scrollHeight - element.clientHeight;
				window.scroll(0, bottom);
			}, 1000);

		}

	}

	loadMap(elemId) {


		//gmap
		if (document.getElementById("map_" + elemId) != null) {
			//initialize();
			console.log('map start -> map_' + elemId);

			if (elemId == "urawa_th") {
				map_urawa_th();
			}
			if (elemId == "kurume_th") {
				map_kurume_th();
			}
			if (elemId == "kurume_footsal") {
				map_kurume_footsal();
			}
			if (elemId == "shintokorozawa_th") {
				map_shintokorozawa_th();
			}


		}
	}

}